import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import Translation from '@s/Translation';
import { withNavigation } from '@b/helpers/withNavigation';

class AddedToCartMessage extends Component {

    transitionToCart = () => {
        this.props.navigate(`/cart/${this.props.token}`);
    }

    render() {
        return( 
            <div className="message message__inline-banner message--success">
                <div className="message__icon">
                    <i className="icon-check" aria-hidden="true" />
                </div>
                <div className="message__text message__text--align-left">
                    <Translation interpolation={{countCartedItems:this.props.countCartedItems}}>{"checkout__added_to_cart"}</Translation>
                </div>
                {!!this.props.canEdit && <div className="message__action">
                    <a onClick={this.transitionToCart}>
                        <i className="icon-mode_edit" aria-hidden="true" /> <Translation>{"checkout__edit"}</Translation>
                    </a>
                </div>}
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        token: state.reservation.token,
    }
}


AddedToCartMessage.propTypes = {
    countCartedItems: PropTypes.number,
    canEdit: PropTypes.bool,
}

export default withNavigation(connect(mapStateToProps, null)(AddedToCartMessage));
